import { z } from 'zod';

export const ZodPassword = z.string().min(4).brand('Password');
export type Password = z.infer<typeof ZodPassword>;
